import { ConfirmationDialog, SectionHeader } from "@shared/components";
import TriggerPushAccordion from "../components/TriggerPushAccordion";
import { Box, Button } from "@mui/material";
import { useState } from "react";
import { usePushTrigger } from "../services/usePushTrigger";
import { Can } from "@core/casl-provider";

const TriggerPush = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { mutateAsync: pushTriggerAsync } = usePushTrigger();

  const handleTriggerPush = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm = async () => {
    try {
      await pushTriggerAsync({ remarks: "" });
      setIsDialogOpen(false);
    } catch (error) {
      console.error("Error triggering push:", error);
    }
  };

  return (
    <>
      <Box sx={{ position: "relative", height: "100%" }}>
        <SectionHeader title="Trigger Push" />
        <TriggerPushAccordion />
        <Can do={"create"} on={"TriggerPush"}>
          <Box
            sx={{
              position: "absolute",
              bottom: 10,
              right: 10,
            }}
          >
            <Button
              variant="contained"
              sx={{ height: 38, padding: "0 20px" }}
              onClick={handleTriggerPush}
            >
              Trigger Push
            </Button>
          </Box>
        </Can>
      </Box>

      <ConfirmationDialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleConfirm}
        title="Trigger Push"
        message="Are you sure you want to push the data?"
        confirmText="Trigger"
        cancelText="Cancel"
        confirmColor="primary"
      />
    </>
  );
};

export default TriggerPush;
